<template>
  <div id="OrderDetails">
    <div class="header2">
      <div class="header2Wrap">
        <div class="header2L">
          <img src="@/assets/list/logo.png" alt />
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <h3>{{ dataList.optDdzt === 0 ? '等待付款'
        : dataList.optDdzt === 1 ? '交易关闭'
          : dataList.optDdzt === 3 ? '等待发货'
            : dataList.optDdzt === 4 ? '等待收货'
              : dataList.optDdzt === 5 ? '等待评价'
                : dataList.optDdzt === 6 ? '退单中'
                  : dataList.optDdzt === 7 ? '退单成功'
                    : dataList.optDdzt === 9 ? '已开发票'
                      : dataList.optDdzt === 10 ? '已完成'
                        : dataList.optDdzt === 11 ? '待回复'
                          : dataList.optDdzt === 12 ? '待用户确认'
                           : dataList.optDdzt === 13 ? '医师拒绝'
                            : dataList.optDdzt === 14 ? '部分退款'
                              : '未知状态' }}</h3>
      <div class="content">
        <div class="add">
          <p class="add1">收货地址：</p>
          <p class="add2">{{ dataList.atShdz }}（{{ dataList.atYhmc }}收）{{ dataList.atLxfs }}</p>
          <!-- <span class="default">默认地址</span> -->
        </div>
        <div class="add SellerInfo" v-show="false">
          <p><b>【卖家信息】</b></p>
          <p>卖家名称：畅通圆</p>
        </div>
        <div class="add OrderInfo">
          <p><b>【订单信息】</b></p>
          <p class="OrderInfoTit">
            <span>订单编号：{{ dataList.id }} &nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span v-if="dataList.spZfgl"> 支付单号：{{ dataList.spZfgl }} &nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>创建时间：{{ dataList.createDate }}</span>
          </p>
        </div>
        <div class="tables">
          <div class="table-header"><span v-if="dataList.optDdzt === 12">原方剂-</span>{{ dataList.cfName }}</div>
          <ul class="Tabtit">
            <li class="Tabtit1 width1">药品名称</li>
            <li class="Tabtit1 width2">数量</li>
            <li class="Tabtit1 width3">单位</li>
            <li class="Tabtit1 width4">单价</li>
            <li class="Tabtit1 width5">优惠类型</li>
            <li class="Tabtit1 width6">商品总价</li>
          </ul>
          <div class="lists" v-for="(item, index) in ddmxList" :key="index">
            <div class="lists1 width1">{{ item.atSpmc }}</div>
            <p class="lists1 width2">{{ item.atSpsl }}</p>
            <p class="lists1 width3">{{ item.unit }}</p>
            <div class="lists1 width4">
              <div class='money' v-if="item.optYhlx != 3">
                <div class="money1">
                  ￥{{ item.atSpje }}
                </div>
                <div class="money2">
                  ￥{{ item.atYjje }}
                </div>
              </div>
              <div class='money'>
                <div class="money3" v-if="item.optYhlx == 3">
                  ￥{{ item.atYjje }}
                </div>
              </div>
            </div>
            <p class="lists1 width5">{{ item.typeName }}</p>
            <p class="lists1 width6 money3">￥{{ item.ypzj }}</p>
          </div>
        </div>
        <div class="sum3">
          <span>处方单剂金额：</span>
          <span>￥{{ dataList.atSpzjeByOneJLOrigin }}</span>
        </div>
        <div class="sum3">
          <span>剂量：</span>
          <span>{{ dataList.atSpzsl }} (剂)</span>
        </div>
        <div class="sum2">
          <span>方剂总额：</span>
          <span>￥{{ dataList.atSpzjeByALLOrigin }}</span>
        </div>
        <div class="sum">
          <span v-if="!dataList.serviceGoodName">药方处理：</span>
          <span v-if="dataList.serviceGoodName">药方{{ dataList.serviceGoodName }}：</span>
          <span>￥{{ dataList.serviceGoodPrice }}</span>
        </div>
       
        <div class="sum2">
          <span>运费：</span>
          <span>￥{{ dataList.atYfje }}</span>
        </div>
        <div class="sum">
          <span>支付金额：</span>
          <span>￥{{ dataList.atSpzje }}</span>
        </div>
        <div  v-if="dataList.acceptDoctor==2 && dataList.optDdzt === 12" >
          <div class="tables">
            <div class="table-header" v-if="dataList.ddmxListModify">修改后-{{ dataList.cfName }}</div>
            <div class="table-header" v-if="!dataList.ddmxListModify">等待专业人士修改方剂...</div>
            <ul class="Tabtit">
            <li class="Tabtit1 width1">药品名称</li>
            <li class="Tabtit1 width2">数量</li>
            <li class="Tabtit1 width3">单位</li>
            <li class="Tabtit1 width4">单价</li>
            <li class="Tabtit1 width5">优惠类型</li>
            <li class="Tabtit1 width6">商品总价</li>
          </ul>
          <div class="lists" v-for="(item, index) in ddmxListModify" :key="index">
            <div class="lists1 width1">{{ item.atSpmc }}</div>
            <p class="lists1 width2">{{ item.atSpsl }}</p>
            <p class="lists1 width3">{{ item.unit }}</p>
            <div class="lists1 width4">
              <div class='money' v-if="item.optYhlx != 3">
                <div class="money1">
                  ￥{{ item.atSpje }}
                </div>
                <div class="money2">
                  ￥{{ item.atYjje }}
                </div>
              </div>
              <div class='money'>
                <div class="money3" v-if="item.optYhlx == 3">
                  ￥{{ item.atYjje }}
                </div>
              </div>
            </div>
            <p class="lists1 width5">{{ item.typeName }}</p>
            <p class="lists1 width6 money3">￥{{ item.ypzj }}</p>
          </div>
           
          </div>
          <div class="sum3"
            v-if="dataList.ddmxListModify && dataList.ddmxListModify.length && dataList.atSpzjeByOneJLModify - 0">
            <span>处方单剂金额：</span>
            <span>￥{{ dataList.atSpzjeByOneJLModify }}</span>
          </div>
          <div class="sum3" v-if="dataList.ddmxListModify && dataList.ddmxListModify.length">
            <span>剂量：</span>
            <span>{{ dataList.atSpzsl }} (剂)</span>
          </div>
          <div class="sum2"
            v-if="dataList.ddmxListModify && dataList.ddmxListModify.length && dataList.atSpzjeByAllModify - 0">
            <span>方剂总额：</span>
            <span>￥{{ dataList.atSpzjeByAllModify }}</span>
          </div>
          <div class="sum" v-if="dataList.ddmxListModify && dataList.ddmxListModify.length">
            <span v-if="!dataList.serviceGoodName">药方处理：</span>
            <span v-if="dataList.serviceGoodName">药方{{ dataList.serviceGoodName }}：</span>
            <span>￥{{ dataList.serviceGoodPrice }}</span>
          </div>
          
          <div class="sum2" v-if="dataList.ddmxListModify && dataList.ddmxListModify.length">
            <span>运费：</span>
            <span>￥{{ dataList.atYfje }}</span>
          </div>

          <div class="sum" v-if="dataList.ddmxListModify && dataList.ddmxListModify.length && dataList.ddmxListModify">
            <span>支付金额：</span>
            <span>￥{{ dataList.atSpzjeModify }}</span>
          </div>
        </div>
      </div>
      <div class="info">
        畅通圆温馨提示，请在购买时严格阅读使用说明书，并按说明书要求服用。处方药请按照医师处方服用。
      </div>
      <div class="btn-btm" v-if="dataList.optDdzt == 12">
        <div class="btn" @click="again(0)">原古方支付</div>
        <div class="btn2" @click="again(1)">接受修改并支付</div>
      </div>
      <div class="btn-btm" v-if="dataList.optDdzt === 0">
			<div class="btn" @click="payment">立即支付</div>
		</div> 
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderDetails",
  data() {
    return {
      dataList: [],
      ddmxList: [],
      ddmxListModify: [],
      userId: "",
      AddressList1: {},//默认地址

    };
  },
  components: {
  },
  created() {
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userId = this.userInfo.id;
    }
    this.getData();
    // this.getAddress();
  },
  methods: {
    getData() {
      var params = {};
      let ddmxList = [];
      let ddmxListModify = [];
      params.id = this.$route.query.id;
      params.createBy = this.userId;
      let url = "/ddgl/getAppIndexListDetailV2";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data;
          this.dataList.createDate = this.getTime(this.dataList.createDate)
          ddmxList = res.data.data.ddmxList ? res.data.data.ddmxList : [];
          ddmxListModify = res.data.data.ddmxListModify ? res.data.data.ddmxListModify : [];
          this.ddmxList = ddmxList.map(item => {
            let typeName;
            let names = item.atSpmc + '(' + item.standard + ')';
            switch (item.optYhlx) {
              case 1:
                typeName = `${item.atZkbl}折优惠`;
                break;
              case 2:
                typeName = '团购';
                break;
              case 3:
                typeName = '无';
                break;
              case 4:
                typeName = '批发商';
                break;
              case 5:
                typeName = '批发';
                break;
              default:
                typeName = '未知类型';
            }
            return {
              ...item,
              typeName,
              names
            };
          });
          this.ddmxListModify = ddmxListModify.map(item => {
            let typeName;
            let names = item.atSpmc + '(' + item.standard + ')';
            switch (item.optYhlx) {
              case 1:
                typeName = `${item.atZkbl}折优惠`;
                break;
              case 2:
                typeName = '团购';
                break;
              case 3:
                typeName = '无';
                break;
              case 4:
                typeName = '批发商';
                break;
              case 5:
                typeName = '批发';
                break;
              default:
                typeName = '未知类型';
            }
            return {
              ...item,
              typeName,
              names
            };
          });
        }
      });
    },
    //    getAddress() {
    //   //获取地址
    //   var params = {};
    //   params.createBy = this.userId;
    //   let url = "/dzgl/getList";
    //   this.$http.post(url, params).then(res => {
    //     if (res.data.code == 200) {
    //       var list = res.data.data.list;
    //        this.AddressList1 = list[0];

    //     }
    //   });
    // },
    goDetail(id) {//跳转商品详情
      if (id) {
        this.$router.push({ path: '/ProductDetails/' + id })
      } else {
        return
      }

    },
    again(val) {
      let dataObj = {};
      dataObj.atJl = this.dataList.atSpzsl; //商品数量
      dataObj.id = this.dataList.id; //订单id
      // 0原古方支付1接受修改并支付
      if (val == 0) {
        dataObj.atSpzje = this.dataList.atSpzje; //订单金额
      } else if (val == 1) {
        dataObj.atSpzje = this.dataList.atSpzjeModify; //订单金额
      }
      var params = {};
      params.id = this.dataList.id;
      params.acceptDoctor = val; //1接受 0 不接受;
      let url = '/ddgl/changeOrderUnpay';
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$router.push({
            path: "/payment",
            query: { id: res.data.data.id }
          });
        } else {
          //错误提示
          this.$api.msg(res.msg);
        }
      }).catch((e) => { });
    },
    payment() {
      //支付
      this.$router.push({ path: "/payment", query: { id: this.dataList.id } });
			},

  }
};
</script>
<style scoped>
.main {
  max-width: 80%;
  width: 1024px;
  margin: 0px auto;
  margin-bottom: 50px;
}

.header2 {
  width: 100%;
  height: 94px;
  background-color: #f64420;
}

.header2Wrap {
  max-width: 80%;
  width: 1024px;
  height: 100%;
  margin: 0px auto;
}

.header2L {
  float: left;
  width: 280px;
  height: 80%;
  margin-top: 10px;
}

.header2L img {
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
}

.content::after {
  content: "";
  height: 0;
  clear: both;
  overflow: hidden;
  display: block;
  visibility: hidden;
}

.add {
  width: 100%;
  height: 56px;
  background-color: #ffffff;
  border: dashed 1px #dddddd;
  box-sizing: border-box;
  padding: 10px;
}

.add p {
  float: left;
  line-height: 36px;
}

.add .add1 {
  height: 36px;
  font-weight: 600;
  width: 80px;
}

.add .add2 {
  width: 800px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.add .default {
  float: left;
  display: block;
  width: 66px;
  height: 20px;
  background-color: #f64420;
  border-radius: 10px;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  letter-spacing: 1px;
  color: #ffffff;
  margin-top: 9px;
}

.add .add3 {
  float: right;
  cursor: pointer;
}

.SellerInfo,
.OrderInfo {
  height: 45px;
  line-height: 45px;
  padding-top: 0;
  padding-bottom: 0;
}

.OrderInfoTit {
  font-size: 13px;
}

.block {
  width: 85%;
  margin: 20px auto;
}

.table-header {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

.tables {
  margin-top: 20px;
  border: solid 1px #dddddd;
  background-color: #f0f0f0;
}

.Tabtit {
  width: 100%;
  height: 47px;
  background-color: #f9f9f9;
  border: solid 1px #dddddd;
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  padding: 10px;

}

.Tabtit li {
  float: left;
  height: 27px;
  line-height: 27px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;
}

.width1,
.width2,
.width3,
.width4,
.width5,
.width6 {
  min-width: 16%;
  text-align: center;
}
.width4 div{
  width:160px;
}
.money1{
  line-height: 18px;
  color: #000;
  font-weight: bold;
  font-size: 16px;
}
.money2{
  line-height: 14px;
  color: #999;
  font-size: 16px;
  text-decoration: line-through;
}
.money3{
  color: #000;
  font-weight: bold;
  font-size: 16px;
}
.lists {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
}

.lists::after {
  content: "";
  display: block;
  overflow: hidden;
  visibility: hidden;
  clear: both;
}

.lists1,
.list2,
.list3,
.list4 {
  height: 30px;
  float: left;
  line-height: 30px;
}

.lists1 .imgs {
  height: 88px;
  width: 116px;
  float: left;
  overflow: hidden;
  /* cursor: pointer; */
}

.lists1 .imgs img {
  width: 100%;
  min-height: 100%;
}

.lists1 p {
  float: left;
  height: 88px;
  width: 200px;
  line-height: 30px;
  margin-left: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  /* cursor: pointer; */
}

.lists1 p:hover {
  /* color:#f64420; */
}

.lists5 {
  height: 98px;
  float: left;
}

.lists5.active1 {
  color: #61baf6;
}

.lists5.active2 {
  color: #f6441e;
}

.lists5 p:nth-child(1) {
  margin-top: 20px;
}

.lists5 p {
  height: 30px;
  line-height: 30px;
}

.counts {
  width: 100%;
  height: 123px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 10px 30px;
}

.countsL {
  float: left;
  width: 60%;
}

.countsL span {
  display: block;
  float: left;
}

.countsL input {
  float: left;
}

.countsR {
  float: right;
  width: 20%;
  margin-top: 0px;
}

.sum {
  margin-top: 20px;
  width: 100%;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ddd;
  border-bottom: none;
  text-align: right;
  box-sizing: border-box;
  padding: 10px;
}

.sum2 {
  width: 100%;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ddd;
  border-top: none;
  text-align: right;
  box-sizing: border-box;
  padding: 10px;
}

.sum3 {
  width: 100%;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ddd;
  border-top: none;
  border-bottom: none;
  text-align: right;
  box-sizing: border-box;
  padding: 10px;
}

.sum span:nth-child(2),
.sum2 span:nth-child(2),
.sum3 span:nth-child(2) {
  color: #f64420;
  font-size: 18px;
}

.info {
  font-size: 13px;
  color: #aaa;
  height: 50px;
  box-sizing: border-box;
  padding: 10px 15px;
}

.bai {
  background-color: #fff;
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #ddd;
}

.btn-btm {
  box-sizing: border-box;
  padding: 10px 15px;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}

.btn2 {
  width: 120px;
  height: 25px;
  font-size: 13px;
  color: #fff;
  background-color: #F64524;
  line-height: 25px;
  text-align: center;
  border: 1px solid #F64524;
  border-radius: 15px;
  box-shadow: 1px 1px 1px 0px #ddd;
  margin-left: 5px;
  cursor: pointer;
}

.btn {
  width: 90px;
  height: 25px;
  font-size: 13px;
  color: #F64524;
  background-color: #fff;
  line-height: 25px;
  text-align: center;
  border: 1px solid #F64524;
  border-radius: 15px;
  box-shadow: 1px 1px 1px 0px #ddd;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/ShoppingMall/OrderCFDetails.vue